var _circle, _g, _g2, _g3, _path, _path2, _g4, _g5, _g6, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 320,
    viewBox: "0 0 304 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 160,
    r: 110,
    fill: "url(#paint0_linear_3105_4059)",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3105_4059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 160,
    r: 102,
    fill: "url(#paint1_linear_3105_4059)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 96,
    width: 106,
    height: 128,
    rx: 16,
    fill: "#2C2D32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.5,
    y: 96.5,
    width: 105,
    height: 127,
    rx: 15.5,
    stroke: "url(#paint2_linear_3105_4059)",
    strokeOpacity: 0.12
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 113,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint3_linear_3105_4059)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 111.5,
    width: 67,
    height: 67,
    rx: 33.5,
    stroke: "#333438",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.241 126.539C151.299 125.82 152.701 125.82 153.759 126.539L167.668 135.978C168.502 136.544 169 137.475 169 138.469V151.531C169 152.525 168.502 153.456 167.668 154.022L153.759 163.461C152.701 164.18 151.299 164.18 150.241 163.461L136.332 154.022C135.498 153.456 135 152.525 135 151.531V138.469C135 137.475 135.498 136.544 136.332 135.978L150.241 126.539Z",
    fill: "#24252A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 138.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 138.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 138.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 145.5,
    r: 2.5,
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 145.5,
    r: 2.5,
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 145.5,
    r: 2.5,
    fill: "#A0A0AB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 152.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 152.5,
    r: 2.5,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159,
    cy: 152.5,
    r: 2.5,
    fill: "#3F3F46"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 224L187 96",
    stroke: "url(#paint4_linear_3105_4059)",
    strokeOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 224L118 96",
    stroke: "url(#paint5_linear_3105_4059)",
    strokeOpacity: 0.08
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 189,
    width: 68,
    height: 18,
    rx: 9,
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 194,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#51525C"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 123,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint6_linear_3105_4059)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.5,
    y: 121.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint7_linear_3105_4059)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3105_4059)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 143,
    r: 6.66667,
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.667 143.333L253 144.667L256.333 141.333",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 123,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint8_linear_3105_4059)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 121.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint9_linear_3105_4059)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9999,
    cy: 139,
    rx: 2.66667,
    ry: 2.66667,
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3334 146.667C55.3334 148.324 55.3334 149.667 50.0001 149.667C44.6667 149.667 44.6667 148.324 44.6667 146.667C44.6667 145.01 47.0546 143.667 50.0001 143.667C52.9456 143.667 55.3334 145.01 55.3334 146.667Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244 112L225.863 112C223.511 112 221.375 113.375 220.401 115.517L213.599 130.483C212.625 132.625 210.489 134 208.137 134L205 134",
    stroke: "url(#paint10_linear_3105_4059)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M244 180L225.863 180C223.511 180 221.375 178.625 220.401 176.483L213.599 161.517C212.625 159.375 210.489 158 208.137 158L205 158",
    stroke: "url(#paint11_linear_3105_4059)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 112L78.1365 112C80.4894 112 82.6251 113.375 83.5987 115.517L90.4013 130.483C91.3749 132.625 93.5106 134 95.8635 134L99 134",
    stroke: "url(#paint12_linear_3105_4059)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 180L78.1365 180C80.4894 180 82.6251 178.625 83.5987 176.483L90.4013 161.517C91.3749 159.375 93.5106 158 95.8635 158L99 158",
    stroke: "url(#paint13_linear_3105_4059)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 142,
    width: 20,
    height: 2,
    fill: "url(#paint14_linear_3105_4059)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    transform: "matrix(-1 0 0 1 20 142)",
    fill: "url(#paint15_linear_3105_4059)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.235 237.804C108.364 236.65 109.91 236 111.524 236H194.253C195.997 236 197.655 236.759 198.795 238.08L210.542 251.69C211.483 252.78 212 254.171 212 255.611V320H92V255.826C92 254.258 92.6141 252.752 93.7108 251.63L107.235 237.804Z",
    fill: "#2C2D32",
    fillOpacity: 0.32
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.592 238.154C108.627 237.096 110.044 236.5 111.524 236.5H194.253C195.852 236.5 197.372 237.196 198.416 238.406L198.795 238.08L198.416 238.406L210.164 252.017C211.026 253.016 211.5 254.291 211.5 255.611V319.5H92.5V255.826C92.5 254.388 93.0629 253.008 94.0682 251.98L107.592 238.154Z",
    stroke: "url(#paint16_linear_3105_4059)",
    strokeOpacity: 0.04
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.235 82.1956C108.364 83.3495 109.91 84 111.524 84H194.253C195.997 84 197.655 83.2409 198.795 81.9203L210.542 68.3098C211.483 67.2202 212 65.8288 212 64.3895V0H92V64.1741C92 65.7425 92.6141 67.2485 93.7108 68.3697L107.235 82.1956Z",
    fill: "#2C2D32",
    fillOpacity: 0.32
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.592 81.8459C108.627 82.9038 110.044 83.5 111.524 83.5H194.253C195.852 83.5 197.372 82.8041 198.416 81.5936L198.795 81.9203L198.416 81.5936L210.164 67.9831C211.026 66.9843 211.5 65.7089 211.5 64.3895V0.5H92.5V64.1741C92.5 65.6118 93.0629 66.9923 94.0682 68.02L107.592 81.8459Z",
    stroke: "url(#paint17_linear_3105_4059)",
    strokeOpacity: 0.04
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186 11L186 29.1365C186 31.4894 184.625 33.6251 182.483 34.5987L167.517 41.4013C165.375 42.3749 164 44.5106 164 46.8635L164 50",
    stroke: "url(#paint18_linear_3105_4059)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118 11L118 29.1365C118 31.4894 119.375 33.6251 121.517 34.5987L136.483 41.4013C138.625 42.3749 140 44.5106 140 46.8635L140 50",
    stroke: "url(#paint19_linear_3105_4059)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 41,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#3F3F46"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_3105_4059)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 58,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#3F3F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3105_4059",
    x: 50,
    y: 54,
    width: 204,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3105_4059",
    x: 83,
    y: 96,
    width: 138,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3105_4059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3105_4059",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_3105_4059",
    x: 105,
    y: 106,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3105_4059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3105_4059",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3105_4059",
    x: 119,
    y: 189,
    width: 68,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3105_4059",
    x: 132,
    y: 194,
    width: 42,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_3105_4059",
    x: 219,
    y: 116,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3105_4059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3105_4059",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_3105_4059",
    x: 15,
    y: 116,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3105_4059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3105_4059",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_3105_4059",
    x: 135,
    y: 41,
    width: 34,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_3105_4059",
    x: 135,
    y: 58,
    width: 34,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0 0.535465 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_4059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3105_4059",
    x1: 152,
    y1: 50,
    x2: 152,
    y2: 270,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2E32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3105_4059",
    x1: 152,
    y1: 58,
    x2: 152,
    y2: 262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26272B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3105_4059",
    x1: 99,
    y1: 96,
    x2: 201.5,
    y2: 224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3105_4059",
    x1: 152,
    y1: 113,
    x2: 152,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3105_4059",
    x1: 187.5,
    y1: 96,
    x2: 187.5,
    y2: 224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3105_4059",
    x1: 118.5,
    y1: 96,
    x2: 118.5,
    y2: 224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3105_4059",
    x1: 244,
    y1: 125.5,
    x2: 265,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3105_4059",
    x1: 234,
    y1: 143,
    x2: 274,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3105_4059",
    x1: 40,
    y1: 125.5,
    x2: 61,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3105_4059",
    x1: 30,
    y1: 143,
    x2: 70,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3105_4059",
    x1: 244,
    y1: 112,
    x2: 205,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3105_4059",
    x1: 244,
    y1: 180,
    x2: 205,
    y2: 157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3105_4059",
    x1: 60,
    y1: 112,
    x2: 99,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3105_4059",
    x1: 60,
    y1: 180,
    x2: 99,
    y2: 157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3105_4059",
    x1: 284,
    y1: 143,
    x2: 304,
    y2: 143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3105_4059",
    x1: 0,
    y1: 1,
    x2: 20,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3105_4059",
    x1: 92,
    y1: 236,
    x2: 144.652,
    y2: 349.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3105_4059",
    x1: 92,
    y1: 84,
    x2: 144.652,
    y2: -29.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3105_4059",
    x1: 186,
    y1: 11,
    x2: 163,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3105_4059",
    x1: 118,
    y1: 11,
    x2: 141,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303134",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474748"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3105_4059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(246 135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.3660a8381a43eab4cfcb0999af655d48.svg";
export { ForwardRef as ReactComponent };